import script from "./Question.vue?vue&type=script&setup=true&lang=ts"
export * from "./Question.vue?vue&type=script&setup=true&lang=ts"

import "./Question.vue?vue&type=style&index=0&id=765b7b0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765b7b0e"]])

export default __exports__